/**
 * @file AdvisorMyClients.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React, { useState } from "react";
import SkinPage from "../../SkinPage";
import Request from "../../../../utils/fetchUtils";
import MyClients from "../../widgets/clients/MyClients";
import Loader from "../../widgets/Loader";

function AdvisorMyClients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetch = async (queryParams = "q=1") => {
    setLoading(true);
    const res = await Request(`/trading/dashboard?${queryParams}`);
    setLoading(false);
    setClients(res.data);
  };

  useState(() => {
    fetch();
  });

  return (
    <SkinPage>
      {loading && <Loader />}
      <MyClients
        customers={clients}
        fetchClients={fetch}
        allocation="strategies"
      />
    </SkinPage>
  );
}

export default AdvisorMyClients;
